import {AccountProfileContextTrait, QuickOnboardingStep} from "@/libwyze-shared/types";
import {BaseApp} from "@/shared/BaseApp";

export function QuickOnboardingStepCompleted(step: QuickOnboardingStep): boolean {
  switch (step) {
    case QuickOnboardingStep.QUICK_SETUP_PROVIDER: {
      const trait = BaseApp.CONTEXT.getTrait<AccountProfileContextTrait>();
      return Boolean(trait?.getProviderPageId());
    }
    case QuickOnboardingStep.QUICK_SETUP_PRACTICE: {
      const trait = BaseApp.CONTEXT.getTrait<AccountProfileContextTrait>();
      return Boolean(trait?.getPracticePageId());
    }
  }
  return false;
}

